import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
    Button,
    PageHeader,
    Space,
    Typography,
} from 'antd';
import { useDriversContext } from './context/drivers.ctx';
import { Driver } from '../../screens/drivers/driver-detail.screen';
import { DriversTable } from './DriversTable';
import { Filters } from './Filters';

const { Title } = Typography;

const Drivers = () => {
    const { t: td } = useTranslation('drivers', { keyPrefix: 'DRIVERS' });

    const {
        drivers,
        driver,
        setPagination,
        pagination,
        total,
        loading,
        handleSearchParam,
        fetchData,
    } = useDriversContext();

    const navigate = useNavigate();

    return (
        <div className="section">

            { driver && <Driver /> }

            <PageHeader
                title={(
                    <Title level={5} style={{ margin: 0 }}>
                        {`${td('DRIVERS_LIST')} (${total || 0})`}
                    </Title>
                )}
                style={{ padding: 0, width: '100%' }}
                extra={(
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => navigate('/drivers/new')}
                    >
                        {td('ADD_DRIVER')}
                    </Button>
                )}
                footer={(
                    <Space direction="vertical" size={24} style={{ width: '100%' }}>
                        <Filters
                            loading={loading}
                            refreshData={fetchData}
                            handleSearchParam={handleSearchParam}
                        />
                        <DriversTable
                            drivers={drivers}
                            setPagination={setPagination}
                            pagination={pagination}
                            total={total}
                            loading={loading}
                        />
                    </Space>
                )}
            />
        </div>
    );
};

export { Drivers };
